export enum TopicType {
    PercentAdv = 'PercentAdv',
    RawCost = 'RawCost',
    Value = 'Value',
    AdjustedCost = 'AdjustedCost',
    Movers = 'Movers',
}
